function getNum(str){
    let newstr = String(str)
    return newstr.substring(0,3) +"." + newstr.substring(3,4) + "k+"
}


export default getNum;